import React, { Component } from 'react';
import Form from '../Components/Form';
import { Footer } from '../Components/Footer';
import TitleCard from '../Components/TitleCard.js';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';


class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    handlerSubmit = (contact) => {
        this.sendEmail(contact);
    }

    sendEmail(contact) {
        this.formRef.setLoading(true);

        fetch(process.env.REACT_APP_API_URL + '/send-email', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(contact)
        }).then(resp => resp.json())
            .then(resp => {                
                this.formRef.resetFields();
                alert("E-mail enviado com sucesso! Entramos em contato em breve.");
            }).catch(err => {
                console.log(err);
                alert("Falha no envio do e-mail. Por favor, tente novamente em alguns instantes.");
            }).finally(() => {
                this.formRef.setLoading(false);
            });
    }

    setFormRef = (ref) => {
        this.formRef = ref;
    }


    render() {
        return (
            <div className="container" style={{
                backgroundImage: `
                    linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0) 15%),
                    linear-gradient(to bottom, rgba(255,255,255,0) 80%, #fff 100%),
                    url('/images/home/background.svg')
            `}}>
                <div className='contact-header-block pt-5'>
                    <div style={{marginBottom: '30px'}}>
                        <img
                            src="/images/icons/home.svg"
                            width="18"
                            alt="Home"
                        />                        
                        <Link to="/" style={{color: '#818181', fontSize: '14px', marginLeft: '10px', textDecoration: 'none'}}>
                            Início
                        </Link>
                        <ChevronRight style={{width: '18px', color: '#818181', marginLeft: '5px'}}/>
                        <span style={{color: '#4654A3', fontSize: '14px', marginLeft: '5px'}}>Contato</span>
                    </div>
                    <TitleCard
                        iconLeft={<img
                            src="/images/icons/Buildings.svg"
                            width="18"
                            alt="Buildings"
                        />}
                        label='FALE COM A GENTE'                            
                    /> 
                    <span className='title-text title-text-xl mt-5'>Entre em Contato</span>
                </div>                
                <div className='d-flex flex-direction-row align-items-center justify-content-center mt-5 mb-5'>
                    <div className='p-3 contact-inner-block'>                        
                        {/* <Alert variant="warning">Contato</Alert> */}
                        {/* <h2>{this.state.date.toLocaleTimeString()}</h2>                     */}

                        <Form ref={this.setFormRef} handlerSubmit={this.handlerSubmit} />

                    </div>
                </div>

                <Footer simple={true} />

            </div>
        );
    }
}

export default Contact;
